export default __webpack_public_path__ + "static/media/I am not a virus.9d0d25a1.jpg";